// extracted by mini-css-extract-plugin
export default {"button":"MainButton_button__k8jUc","disabled":"MainButton_disabled__kP-lb"};